"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseOrderDeliveryStatusEnum = void 0;
var PurchaseOrderDeliveryStatusEnum;
(function (PurchaseOrderDeliveryStatusEnum) {
    PurchaseOrderDeliveryStatusEnum["FULLY_DELIVERED"] = "fullyDelivered";
    PurchaseOrderDeliveryStatusEnum["PARTIALLY_DELIVERED"] = "partiallyDelivered";
    PurchaseOrderDeliveryStatusEnum["NOT_DELIVERED"] = "notDelivered";
})(PurchaseOrderDeliveryStatusEnum || (exports.PurchaseOrderDeliveryStatusEnum = PurchaseOrderDeliveryStatusEnum = {}));
